var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi3388671(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_926_4491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 2.29167C19.1667 1.02583 18.1408 0 16.875 0H7.29167C6.02583 0 5 1.02583 5 2.29167V13.5417C5 14.8075 6.02583 15.8333 7.29167 15.8333H16.875C18.1408 15.8333 19.1667 14.8075 19.1667 13.5417V2.29167ZM15.2083 12.0833H8.95833C8.61333 12.0833 8.33333 11.8033 8.33333 11.4583C8.33333 11.1133 8.61333 10.8333 8.95833 10.8333H15.2083C15.5533 10.8333 15.8333 11.1133 15.8333 11.4583C15.8333 11.8033 15.5533 12.0833 15.2083 12.0833ZM15.2083 9.58333H8.95833C8.61333 9.58333 8.33333 9.30333 8.33333 8.95833C8.33333 8.61333 8.61333 8.33333 8.95833 8.33333H15.2083C15.5533 8.33333 15.8333 8.61333 15.8333 8.95833C15.8333 9.30333 15.5533 9.58333 15.2083 9.58333ZM15.2083 7.08333H8.95833C8.61333 7.08333 8.33333 6.80333 8.33333 6.45833C8.33333 6.11333 8.61333 5.83333 8.95833 5.83333H15.2083C15.5533 5.83333 15.8333 6.11333 15.8333 6.45833C15.8333 6.80333 15.5533 7.08333 15.2083 7.08333Z",
    fill: "#5D616C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29036 17.0835C5.33703 17.0835 3.7487 15.4943 3.7487 13.5418V2.29183C3.7487 2.22016 3.76536 2.1535 3.76953 2.0835H3.1237C1.85953 2.0835 0.832031 3.111 0.832031 4.37516V17.7085C0.832031 18.9727 1.85953 20.0002 3.1237 20.0002H13.1237C14.3879 20.0002 15.4154 18.9727 15.4154 17.7085V17.0835H7.29036Z",
    fill: "#5D616C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_4491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi3388671);
export default __webpack_public_path__ + "static/media/fi_3388671.97a4731d088b34fb3024185111728f03.svg";
export { ForwardRef as ReactComponent };